import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { on } from '@ember/modifier';
import { ajax } from 'discourse/lib/ajax';
import { fn, mut } from '@ember/helper';

export default class ProxyviewsVendorDashboard extends Component {
  @service dialog;
  @service router;

  @tracked editingDescription = this.args.model?.provider?.description || '';
  @tracked editingPricing = this.args.model?.provider?.pricing_tiers
    ? JSON.stringify(this.args.model.provider.pricing_tiers, null, 2)
    : '';
  @tracked isSaving = false;
  @tracked provider = this.args.model?.provider;

  @action
  async saveChanges() {
    this.isSaving = true;

    let parsedPricing;
    try {
      parsedPricing = JSON.parse(this.editingPricing);
    } catch (e) {
      this.dialog.alert('Pricing JSON is invalid.');
      this.isSaving = false;
      return;
    }

    try {
      const response = await ajax(
        `/vendor/proxyviews-directory/providers/${this.provider?.slug}`,
        {
          type: 'PUT',
          data: {
            description: this.editingDescription,
            pricing_tiers: parsedPricing,
          },
        }
      );
      this.dialog.alert('Changes saved successfully!');
      this.provider = response.provider || response;
    } catch (e) {
      this.dialog.alert(
        e.jqXHR?.responseJSON?.errors?.[0] || 'Failed to save changes.'
      );
    } finally {
      this.isSaving = false;
    }
  }

  <template>
    <div class="container proxyviews-directory-container">
      <div class="pd-hero">
        <div class="pd-hero__header">
          <h1>Vendor Dashboard: {{this.provider.name}}</h1>
          <p>Manage your public directory listing</p>
        </div>
      </div>

      <div class="pd-grid">
        <div class="pd-card" style="grid-column: span 12;">
          <h2>Edit Listing</h2>

          <div class="pd-form-group">
            <label>Description</label>
            <textarea
              class="pd-input"
              rows="6"
              value={{this.editingDescription}}
              {{on "input" (fn (mut this.editingDescription))}}
            ></textarea>
          </div>

          <div class="pd-form-group">
            <label>Pricing Tiers (JSON format)</label>
            <textarea
              class="pd-input"
              rows="10"
              style="font-family: monospace;"
              value={{this.editingPricing}}
              {{on "input" (fn (mut this.editingPricing))}}
            ></textarea>
          </div>

          <button
            type="button"
            class="pd-btn pd-btn--primary"
            disabled={{this.isSaving}}
            {{on "click" this.saveChanges}}
          >
            {{if this.isSaving "Saving..." "Save Changes"}}
          </button>
        </div>
      </div>
    </div>
  </template>
}
